// Theme: energy-orange
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'energy-orange',
  name: 'ENERGY ORANGE',
  tagline: 'ENERGY ORANGE',
  description: 'Laranja de alta intensidade com gradiente radial e glow controlado.',
  category: 'system-core',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#2A1208', '#3D1C10', '#FF6A2A', '#FFE0CF'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-energy-orange'
  },
  colorVars: {
    '--accent': '#FF6A2A',
    '--accent-foreground': '#2A1208',
    '--background': '#2A1208',
    '--border': '#C05A25',
    '--card': '#3D1C10',
    '--card-border-active': 'rgba(255, 106, 42, 0.78)',
    '--card-completed': '#32170D',
    '--card-foreground': '#FFE0CF',
    '--card-glow': 'rgba(255, 106, 42, 0.18)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#FFE0CF',
    '--hold-fill': '#FF6A2A',
    '--input': '#C05A25',
    '--modal-bg': '#2A1208',
    '--modal-border': '#C05A25',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#C05A25',
    '--muted-foreground': '#FFE0CF',
    '--nav-active': '#FF6A2A',
    '--nav-bg': '#3D1C10',
    '--popover': '#3D1C10',
    '--popover-foreground': '#FFE0CF',
    '--primary': '#FF6A2A',
    '--primary-foreground': '#2A1208',
    '--ring': '#FF6A2A',
    '--secondary': '#C05A25',
    '--secondary-foreground': '#FFE0CF',
    '--streak': '#FF6A2A',
    '--success': '#22c55e',
    '--success-foreground': '#2A1208',
    '--xp': '#FF6A2A',
    '--xp-bg': '#3D1C10'
  },
  resolvedVars: {
    '--accent': '#FF6A2A',
    '--accent-foreground': '#2A1208',
    '--accent-foreground-hsl': '18 68% 10%',
    '--accent-foreground-oklch': 'from #2A1208 l c h',
    '--accent-hsl': '18 100% 58%',
    '--accent-oklch': 'from #FF6A2A l c h',
    '--background': '#2A1208',
    '--background-hsl': '18 68% 10%',
    '--background-oklch': 'from #2A1208 l c h',
    '--border': '#C05A25',
    '--border-hsl': '21 68% 45%',
    '--border-oklch': 'from #C05A25 l c h',
    '--border-w': '1px',
    '--card': '#3D1C10',
    '--card-border-active': 'rgba(255, 106, 42, 0.78)',
    '--card-completed': '#32170D',
    '--card-completed-hsl': '16 59% 12%',
    '--card-completed-oklch': 'from #32170D l c h',
    '--card-foreground': '#FFE0CF',
    '--card-foreground-hsl': '21 100% 91%',
    '--card-foreground-oklch': 'from #FFE0CF l c h',
    '--card-glow': 'rgba(255, 106, 42, 0.18)',
    '--card-hsl': '16 58% 15%',
    '--card-oklch': 'from #3D1C10 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FFE0CF',
    '--foreground-hsl': '21 100% 91%',
    '--foreground-oklch': 'from #FFE0CF l c h',
    '--hold-fill': '#FF6A2A',
    '--hold-fill-hsl': '18 100% 58%',
    '--hold-fill-oklch': 'from #FF6A2A l c h',
    '--input': '#C05A25',
    '--input-hsl': '21 68% 45%',
    '--input-oklch': 'from #C05A25 l c h',
    '--modal-bg': '#2A1208',
    '--modal-bg-hsl': '18 68% 10%',
    '--modal-bg-oklch': 'from #2A1208 l c h',
    '--modal-border': '#C05A25',
    '--modal-border-hsl': '21 68% 45%',
    '--modal-border-oklch': 'from #C05A25 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#C05A25',
    '--muted-foreground': '#FFE0CF',
    '--muted-foreground-hsl': '21 100% 91%',
    '--muted-foreground-oklch': 'from #FFE0CF l c h',
    '--muted-hsl': '21 68% 45%',
    '--muted-oklch': 'from #C05A25 l c h',
    '--nav-active': '#FF6A2A',
    '--nav-active-hsl': '18 100% 58%',
    '--nav-active-oklch': 'from #FF6A2A l c h',
    '--nav-bg': '#3D1C10',
    '--nav-bg-hsl': '16 58% 15%',
    '--nav-bg-oklch': 'from #3D1C10 l c h',
    '--popover': '#3D1C10',
    '--popover-foreground': '#FFE0CF',
    '--popover-foreground-hsl': '21 100% 91%',
    '--popover-foreground-oklch': 'from #FFE0CF l c h',
    '--popover-hsl': '16 58% 15%',
    '--popover-oklch': 'from #3D1C10 l c h',
    '--primary': '#FF6A2A',
    '--primary-foreground': '#2A1208',
    '--primary-foreground-hsl': '18 68% 10%',
    '--primary-foreground-oklch': 'from #2A1208 l c h',
    '--primary-hsl': '18 100% 58%',
    '--primary-oklch': 'from #FF6A2A l c h',
    '--radius': '10px',
    '--ring': '#FF6A2A',
    '--ring-hsl': '18 100% 58%',
    '--ring-oklch': 'from #FF6A2A l c h',
    '--secondary': '#C05A25',
    '--secondary-foreground': '#FFE0CF',
    '--secondary-foreground-hsl': '21 100% 91%',
    '--secondary-foreground-oklch': 'from #FFE0CF l c h',
    '--secondary-hsl': '21 68% 45%',
    '--secondary-oklch': 'from #C05A25 l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#FF6A2A',
    '--streak-hsl': '18 100% 58%',
    '--streak-oklch': 'from #FF6A2A l c h',
    '--success': '#22c55e',
    '--success-foreground': '#2A1208',
    '--success-foreground-hsl': '18 68% 10%',
    '--success-foreground-oklch': 'from #2A1208 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(18 100% 58% / 0.15)',
    '--xp': '#FF6A2A',
    '--xp-bg': '#3D1C10',
    '--xp-bg-hsl': '16 58% 15%',
    '--xp-bg-oklch': 'from #3D1C10 l c h',
    '--xp-hsl': '18 100% 58%',
    '--xp-oklch': 'from #FF6A2A l c h'
  }
}
